<template lang="html">
  <div>
    <div id="hideImg">
      <div class="share-container" id="shareImg">
        <div class="bg">
          <img src="~mobile/pic/shareWx/logo_w.png" class="logo"/>
          <div class="content-bg">
            <div class="content">
              <div class="title" v-if="tct.hide_title == 0">{{tct.title}}</div>
              <div class="title" v-else>{{theme_info.title}}</div>
              <div class="summary" v-html="tct.summary"></div>
              <div class="img-area">
                <div class="tct_1" v-if="tct.mode_type == 0">
                  <div class="legends">
                    <div class="legend" v-for="item,index in tct.content.x" :key="index">
                      <div class="color-block" :style="{'background-color' : colors1[index] || 'rgba(250, 122, 80, 1)'}"></div>
                      <p :style="{'color' : colors1[index] || 'rgba(250, 122, 80, 1)'}">{{item.short_name}}</p>
                    </div>
                  </div>
                  <OrgContrast :cItem="tct" :uid="theme_info.uid" :entityNtag="entity_ntag" @greatImg="greatImg"></OrgContrast>
                </div>
                <div class="tct_2" v-if="tct.mode_type == 1">
                  <div class="legends">
                    <div class="legend" v-for="item,index in tct.content.x" :key="index">
                      <div class="color-block" :style="{'background-color' : colors2[index] || 'rgba(250, 122, 80, 1)'}"></div>
                      <p :style="{'color' : colors2[index] || 'rgba(250, 122, 80, 1)'}">{{item | dealNeed(annotation_tag)}}</p>
                    </div>
                  </div>
                  <PointTime :cItem="tct" :uid="theme_info.uid" :annotationTag="annotation_tag" :address="address" @greatImg="greatImg"></PointTime>
                </div>
                <PointTag :cItem="tct" :uid="theme_info.uid" v-if="tct.mode_type == 2" :annotationTag="annotation_tag" :address="address" @greatImg="greatImg"></PointTag>
                <CompanySankey :cItem="tct" :uid="theme_info.uid" v-if="tct.mode_type == 3" :entityNtag="entity_ntag" :tctBusinessNature="tct_business_nature" @greatImg="greatImg"></CompanySankey>
              </div>
            </div>
          </div>
          <div class="content-footer">数据来源：动脉橙产业智库</div>
          <div class="footer">
            <img :src="xcx_code" />
            <p>进入小程序，查看更多详情</p>
          </div>
        </div>
      </div>
    </div>
    <div id="showImg">
      <img :src="imgbase" class="show_img"/>
    </div>

    <div class="loading_img" v-if="loading">
      <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
    </div>
  </div>
</template>

<script>
import {
  getTctData,
  getMeta
} from '../service'
import PointTag from './PointTag'
import OrgContrast from './OrgContrast'
import PointTime from './PointTime'
import CompanySankey from './CompanySankey'
import html2canvas from 'html2canvas'
import { share } from 'mobile/js/wx_share'
import { getTableById, wxShare, getdgxcxcode } from '../service'
export default {
  data() {
    return {
      colors1: ['#9254DE', '#40A9FF', '#1EA69B', '#FFCB6A', '#E96350'],
      colors2: ['#E96350','#FFCB6A','#A6D911','#36CFC9','#40A9FF','#F88C52','#FFCCBC','#53C419','#1EA69B','#2F54EB'],
      tct: '',
      theme_info: '',
      address: '',
      entity_ntag: '',
      round: '',
      annotation_tag: '',
      tct_business_nature: '',
      imgbase: '',
      xcx_code: '',
      loading: true,
      loading1: false,
      loading2: false,
      loading3: false
    }
  },
  components: {
    PointTag, OrgContrast, PointTime, CompanySankey
  },
  computed: {
    getLoading() {
      return this.loading1 && this.loading2 && this.loading3
    }
  },
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['address', 'entity_ntag', 'round', 'annotation_tag', 'tct_business_nature']
      })
      if (res.status == 'success') {
        this.address = res.meta.address
        this.entity_ntag = res.meta.entity_ntag
        this.round = res.meta.round
        this.annotation_tag = res.meta.annotation_tag
        this.tct_business_nature = res.meta.tct_business_nature
        this.getTctData()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getTctData() {
      let res = await getTctData({
        tct_id: this.$route.query.tct_id,
        theme_uid: this.$route.query.theme_uid
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'theme_info', res.theme_info[0])
        this.$set(this.$data, 'tct', res.tct[0])

        this.loading1 = true
        this.themeShare()
      } else {
        this.$Message.error(res.message)
      }
    },
    handleCreateImage() {
      let targetDom = document.getElementById('shareImg');
      html2canvas(targetDom, {
        scale: 1,
        taintTest: true,
        useCORS: true,
        height: targetDom.offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
        width: targetDom.offsetWidth,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        x: 0,
        y: 0,
        dpi: window.devicePixelRatio * 2,
      }).then((canvas) => {
        let save_url= canvas.toDataURL("image/png")
        this.$set(this.$data, 'imgbase', save_url)
        this.loading = false
      })
    },
    greatImg(val) {
      this.loading3 = val
    },
    async themeShare() {
      let res = await wxShare({"url":this.$store.state.req_url+"/mindex" + this.$route.fullPath},
        (error) => { this.$Message.error('请求错误!') }
      )
      share(res, {
        title: this.theme_info.title,
        desc: this.theme_info.unsign_summary,
        link: this.$store.state.req_url + '/mindex' + this.$route.fullPath,
        imgUrl: this.$store.state.req_url+'/share_pro.png'
      }, this, window.location.href)
    },
    async getXcxCode() {
      let res = await getdgxcxcode({
        page: 'pages/themeDetail/themeDetail',
        scene: this.$route.query.theme_uid
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.xcx_code = 'data:image/png;base64,' + res.info
        this.$nextTick(() => {this.loading2 = true})
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getMeta()
  },
  mounted() {
    this.getXcxCode()
  },
  watch: {
    getLoading(val) {
      if(val) {
        setTimeout(() => {
            this.handleCreateImage()
        }, 500);
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/shareLoading.stylus'
@import '~mobile/styles/shareWx.stylus'
#hideImg
  overflow: hidden
  height: 0
  width: 0
#showImg img
  width: 100%
  display: block
.legends
  display: flex;
  flex-wrap: wrap;
  margin-right: -40px;
  margin-top: -10px;
  padding-top: 20px;
  pad
  .legend
    margin-top: 16px;
    margin-right: 40px;
    display: flex;
    align-items: center;
    p
      font-size: 24px
    .color-block
      width: 16px;
      height: 16px;
      background: #40A9FF;
      margin-right: 20px;
</style>
